export const entityTypeMap = {
  '8': 'PROPRIETORSHIP',
  '9': 'PARTNERSHIP',
  '10': 'PRIVATE_LIMITED_COMPANY',
  '11': 'LIMITED_LIABILITY_PARTNERSHIP_FIRM',
  '12': 'TRUST',
  '13': 'PUBLIC_LIMITED_COMPANY',
  '14': 'SOCIETIES',
  '15': 'OPC',
};

export const togglePath = '/toggle';

export const keyValueMap = {
  PROOF_OF_IDENTITY: 'Proof of Identity',
  BUSINESS_LEGALITY_PROOF: 'Business Legality Proof',
  PROOF_OF_BUSINESS_ADDRESS: 'Proof of Business Address',
  BANK_ACCOUNT_DETAILS: 'Bank Account Details',
  INDIVIDUAL_PAN: 'PAN Card',
  AADHAAR: 'Aadhaar card',
  PASSPORT: 'Passport',
  VOTER_ID: 'Voter ID card',
  DRIVING_LICENSE: 'Driving License',
  TRADE_LICENSE:
    'Trade License issued by the local authority in the name of the proprietor containing address of the firm.',
  SE_CERTIFICATE:
    'Shop & Establishment Certificate issued by a Civic Authority',
  GST: 'GST Certificate',
  CANCELLED_CHEQUE: 'Cancelled Cheque',
  BANK_STATEMENT: 'Bank Statement',
  PASSBOOK: 'Passbook copy',
  BANK_VERIFICATION_LETTER: 'Bank Verification Letter',
  BUSINESS_PAN: 'Business PAN Card',
  PARTNERSHIP_DEED: 'Partnership Deed (with registration certificate)',
  MOA_AOA: 'Memorandum and Articles of Association',
  CERTIFICATE_OF_INCORPORATION: 'Certificate of Incorporation',
  BOARD_RESOLUTION:
    'Certified true copy of the board resolution with authorized officials name',
  REGISTRATION_CERTIFICATE_OF_TRUST_DEED:
    'Registration Certificate of Trust deed',
  AUTHORITY_LETTER: 'Authority letter for authorized signatory by members',
  TRUST_DEED: 'Trust Deed',
  UTILITY_BILLS: 'Latest copy of electricity bill in the name of applicant for a period of 3 Months',
  SOCIETY_DEED: 'Registration Certificate of Society deed',
  SOCIETY_BYE_LAWS: 'Society Bye-laws',
};

export const valueKeyMap = {
  'Proof of Identity': 'PROOF_OF_IDENTITY',
  'Business Legality Proof': 'BUSINESS_LEGALITY_PROOF',
  'Proof of Business Address': 'PROOF_OF_BUSINESS_ADDRESS',
  'Bank Account Details': 'BANK_ACCOUNT_DETAILS',
  'PAN Card': 'INDIVIDUAL_PAN',
  'Aadhaar card': 'AADHAAR',
  Passport: 'PASSPORT',
  'Voter ID card': 'VOTER_ID',
  'Driving License': 'DRIVING_LICENSE',
  'Trade License issued by the local authority in the name of the proprietor containing address of the firm.':
    'TRADE_LICENSE',
  'Shop & Establishment Certificate issued by a Civic Authority':
    'SE_CERTIFICATE',
  'GST Certificate': 'GST',
  'Cancelled Cheque': 'CANCELLED_CHEQUE',
  'Bank Statement': 'BANK_STATEMENT',
  'Passbook copy': 'PASSBOOK',
  'Bank Verification Letter': 'BANK_VERIFICATION_LETTER',
  'Business PAN Card': "BUSINESS_PAN",
  'Partnership Deed (with registration certificate)':"PARTNERSHIP_DEED",
  'Memorandum and Articles of Association':"MOA_AOA",
   'Certificate of Incorporation':'CERTIFICATE_OF_INCORPORATION',
  'Certified true copy of the board resolution with authorized officials name':"BOARD_RESOLUTION",
  'Registration Certificate of Trust deed':"REGISTRATION_CERTIFICATE_OF_TRUST_DEED",
  'Authority letter for authorized signatory by members':"AUTHORITY_LETTER",
  'Trust Deed':"TRUST_DEED",
  'Latest copy of electricity bill in the name of applicant for a period of 3 Months':"UTILITY_BILLS",
  'Registration Certificate of Society deed':"SOCIETY_DEED",
  'Society Bye-laws':"SOCIETY_BYE_LAWS",
};

export const BankDetailsTemplate = {
  kycCategory: 'BANK_ACCOUNT_DETAILS',
  status: 'SUCCESS',
  documents: [
    {
      anyOneOf: [
        'CANCELLED_CHEQUE',
        'BANK_STATEMENT',
        'PASSBOOK',
        'BANK_VERIFICATION_LETTER',
      ],
      status: 'PENDING',
    },
  ],
};

export const location = 'India';
export const product = 'PLURAL';
